import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { useAuth } from "../../Context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import cafeLogo from "../../Assets/logo.png";

const ClientHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const handleLogout = () => {
    setMobileSidebarOpen(false);
    logout();
    navigate("/login");
  };



  const goToMakeOrder = () => {
    setMobileSidebarOpen(false);
    navigate("/clint/make-order");
  };

  const goToMyOrders = () => {
    setMobileSidebarOpen(false);
    navigate("/clint/orders/history");
  };

  const goToMenu = () => {
    setMobileSidebarOpen(false);
    navigate("/clint/menu");
  };

  const isMenuActive = location.pathname.startsWith("/clint/menu");
  const isOrdersActive = location.pathname.startsWith("/clint/orders");
  const isMakeOrderActive =
    location.pathname.startsWith("/clint/make-order") ||
    location.pathname.startsWith("/clint/make-drink");

  const activePageLabel = isMakeOrderActive
    ? "إنشاء طلب"
    : isMenuActive
      ? "المنيو"
      : isOrdersActive
        ? "طلباتي"
        : "الرئيسية";

  const navItems = [
    {
      label: "إنشاء طلب",
      icon: <AddShoppingCartRoundedIcon />,
      active: isMakeOrderActive,
      onClick: goToMakeOrder,
      color: "success",
    },
    {
      label: "المنيو",
      icon: <MenuBookRoundedIcon />,
      active: isMenuActive,
      onClick: goToMenu,
      color: "primary",
    },
    {
      label: "طلباتي",
      icon: <ReceiptLongRoundedIcon />,
      active: isOrdersActive,
      onClick: goToMyOrders,
      color: "primary",
    },
  ];

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(8px)",
        borderBottom: "1px solid",
        borderColor: "divider",
        color: "text.primary",
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: "64px !important", md: "72px !important" },
          gap: 1.5,
          flexWrap: "nowrap",
          py: { xs: 0.75, md: 0 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
          <Box
            component="img"
            src={cafeLogo}
              alt="Nuvvy"
              sx={{
              width: { xs: 38, md: 42 },
              height: { xs: 38, md: 42 },
              objectFit: "contain",
              borderRadius: 1.5,
              boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
            }}
          />
          <Box>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 900, letterSpacing: "0.04em", lineHeight: 1.1 }}
            >
              Nuvvy
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: { xs: "none", sm: "block" }, fontWeight: 600 }}>
              Client Area
            </Typography>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            alignItems: "center",
            gap: 0.75,
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.6,
              px: 0.9,
              py: 0.45,
              borderRadius: 99,
              bgcolor: "action.hover",
              minWidth: 0,
              maxWidth: "46vw",
            }}
          >
            <Avatar sx={{ width: 28, height: 28, bgcolor: "primary.main", fontSize: 13, flexShrink: 0 }}>
              {user?.name?.charAt(0) || "U"}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="caption" sx={{ display: "block", fontWeight: 800, lineHeight: 1.1 }} noWrap>
                {user?.name || "User"}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", fontWeight: 700, lineHeight: 1.1 }} noWrap>
                {activePageLabel}
              </Typography>
            </Box>
          </Box>

          <IconButton
            onClick={() => setMobileSidebarOpen(true)}
            aria-label="open client menu"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              color: "primary.main",
              bgcolor: "background.paper",
            }}
          >
            <MenuRoundedIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: 1,
            flexWrap: "nowrap",
            width: "auto",
            justifyContent: "flex-end",
          }}
        >
          {navItems.map((item) => (
            <Button
              key={item.label}
              variant={item.active ? "contained" : "outlined"}
              color={item.active ? item.color : "inherit"}
              startIcon={item.icon}
              onClick={item.onClick}
              sx={{ fontWeight: 700, borderRadius: 2, px: 1.5 }}
            >
              {item.label}
            </Button>
          ))}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              px: 1,
              py: 0.5,
              borderRadius: 99,
              bgcolor: "action.hover",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {user?.name || "User"}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 800 }}>
              {activePageLabel}
            </Typography>
            <Avatar sx={{ width: 30, height: 30, bgcolor: "primary.main", fontSize: 14 }}>
              {user?.name?.charAt(0) || "U"}
            </Avatar>
          </Box>

          <IconButton
            onClick={handleLogout}
            aria-label="logout"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              color: "error.main",
            }}
          >
            <ExitToAppIcon />
          </IconButton>
        </Box>
      </Toolbar>

      <Drawer
        anchor="right"
        open={mobileSidebarOpen}
        onClose={() => setMobileSidebarOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            maxWidth: "82vw",
            p: 2,
            direction: "rtl",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              component="img"
              src={cafeLogo}
              alt="Nuvvy"
              sx={{ width: 38, height: 38, objectFit: "contain", borderRadius: 1.25 }}
            />
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 900, lineHeight: 1.1 }}>
                Nuvvy
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
                {user?.name || "User"} - {activePageLabel}
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={() => setMobileSidebarOpen(false)} aria-label="close client menu">
            <CloseRoundedIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 1 }} />

        <List sx={{ display: "grid", gap: 0.75 }}>
          {navItems.map((item) => (
            <ListItemButton
              key={item.label}
              selected={item.active}
              onClick={item.onClick}
              sx={{
                borderRadius: 2,
                minHeight: 48,
                "&.Mui-selected": {
                  bgcolor: item.color === "success" ? "success.main" : "primary.main",
                  color: "common.white",
                  "&:hover": {
                    bgcolor: item.color === "success" ? "success.dark" : "primary.dark",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "common.white",
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 38 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontWeight: 800 }}
              />
            </ListItemButton>
          ))}
        </List>

        <Divider sx={{ my: 1.5 }} />

        <Button
          variant="outlined"
          color="error"
          onClick={handleLogout}
          startIcon={<ExitToAppIcon />}
          fullWidth
          sx={{
            height: 42,
            borderRadius: 2,
            justifyContent: "center",
            fontWeight: 800,
            px: 1.5,
            mt: 0.5,
          }}
        >
          تسجيل الخروج
        </Button>
      </Drawer>
    </AppBar>
  );
};

export default ClientHeader;
